import classNames from 'classnames';
import type { PriorityCharProps } from './priorityChar.types';
import './priorityChar.scss';

/**
 * Renders the single-character priority badge of an event. Wraps the character in a priority-char container merged with the caller's className.
 *
 * @param className - Extra class controlling the badge colour.
 * @param char - Single priority character to display.
 * @returns The priority badge element.
 */
const PriorityChar = ({ className, char }: PriorityCharProps) => (
  <div className={classNames('priority-char', className)}>
    <span>{char}</span>
  </div>
);

export default PriorityChar;
